/**
 * 카메라 상태 공유 스토어
 *
 * Building Canvas에서 생성된 CameraActions 인스턴스를
 * Background Canvas 등 다른 캔버스에서 접근할 수 있도록 함
 */
import { create } from "zustand";
import * as THREE from "three";
import type { CameraActions } from "@/three/events";

interface CameraObservableState {
  /** CameraActions 인스턴스 (Building Canvas에서 등록) */
  cameraActions: CameraActions | null;

  /** CameraActions 인스턴스 등록 */
  setCameraActions: (actions: CameraActions | null) => void;

  /** 현재 panOffset 가져오기 */
  getPanOffset: () => THREE.Vector3;

  /** 현재 zoom 가져오기 */
  getZoom: () => number;
}

export const useCameraObservableStore = create<CameraObservableState>(
  (set, get) => ({
    cameraActions: null,

    setCameraActions: (actions) => set({ cameraActions: actions }),

    getPanOffset: () => {
      const { cameraActions } = get();
      if (cameraActions) {
        return cameraActions.getPanOffset();
      }
      return new THREE.Vector3();
    },

    getZoom: () => {
      const { cameraActions } = get();
      if (cameraActions) {
        return cameraActions.getZoom();
      }
      return 1.0;
    },
  })
);
